/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_LocaleInputs */

const en_settings_profile_locale = /** @type {(inputs: Settings_Profile_LocaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interface language`)
};

const id_settings_profile_locale = /** @type {(inputs: Settings_Profile_LocaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa antarmuka`)
};

/**
* | output |
* | --- |
* | "Interface language" |
*
* @param {Settings_Profile_LocaleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_profile_locale = /** @type {((inputs?: Settings_Profile_LocaleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_LocaleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_profile_locale(inputs)
	return en_settings_profile_locale(inputs)
});